import React from 'react';
import PropTypes from 'prop-types';

import getDetails from '../../../../../modules/getOrderStatusDetails';
import { Text } from './style';

const Status = ({ value }) => {
  const details = getDetails(value);

  return <Text color={details.color}>{details.text}</Text>;
};

Status.propTypes = {
  value: PropTypes.string,
};

Status.defaultProps = {
  value: '',
};

export default Status;
